import styled from "@emotion/styled";

export const ContactWrapper = styled.div`
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
`;
export const Image = styled.img`
  max-width: 22%;
  margin: 0 auto;
  margin-bottom: 1rem;
  border: 10px solid transparent;
  border-radius: 15px;
  box-shadow: 3px 3px 3px 5px #151418 ;
  display: block;
  object-fit: cover;
`;

export const Technologies = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: -1rem;
`;

export const Tech = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 100px;
  min-width: 100px;
  margin-bottom: 2rem;
`;

export const TechImg = styled.img`
  height: 40px;
  width: 40px;
  padding-bottom: 5px;
`;

export const TechName = styled.div`
  font-size: 14px;
  color: white;
`;

export const AboutWrapper = styled.div`
  background-size: cover; 
  background-repeat: no-repeat; 
  background-position: center;
  padding-top: 2rem;
  padding-bottom: 2rem;
  width: 100%;
`;